<template>
  <div>
    <p class="text-center">
      Total de pacientes:
      <v-chip
        label
        color="blue lighten-4"
        class="font-work-sans font-weight-bold primary--text"
        >{{ items.length }}
      </v-chip>
    </p>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      disable-sort
      hide-default-footer
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.patient="{ item }">
        {{ patientName(item) }}
      </template>
      <template v-slot:item.priority="{ item }">
        {{ priorityLabel(item.priorityId) }}
      </template>
      <template v-slot:item.isUnderage="{ item }">
        {{ yesNo(item.isUnderage) }}
      </template>
      <template v-slot:item.severalPatients="{ item }">
        {{ yesNo(item.severalPatients) }}
      </template>
      <template v-slot:item.samplingStationId="{ item }">
        {{ item.samplingStationId || '—' }}
      </template>
      <template v-slot:item.isCalled="{ item }">
        {{ yesNo(item.isCalled) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
const PRIORITY_VALUES = {
  1: 'Directo a estación',
  2: 'Prioridad',
  4: 'Particular',
  5: 'Domicilio',
  7: 'Prioridad absoluta',
}

export default {
  name: 'Sampling',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Número',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'number',
      },
      {
        text: 'Paciente',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient',
      },
      {
        text: 'Prioridad',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'priority',
      },
      {
        text: 'Menor de edad',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'isUnderage',
      },
      {
        text: 'Varios pacientes',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'severalPatients',
      },
      {
        text: 'Estación',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'samplingStationId',
      },
      {
        text: 'Llamado',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'isCalled',
      },
    ],
  }),
  methods: {
    patientName(item) {
      return `${item.firstName || ''} ${item.lastName || ''}`.trim()
    },
    priorityLabel(priorityId) {
      return PRIORITY_VALUES[priorityId] || priorityId || '—'
    },
    yesNo(value) {
      return value == null ? '—' : value ? 'Sí' : 'No'
    },
  },
}
</script>
